import { occFetch, occUrl } from "~/app/api/occ/occFetch";

export const sendLinearConfigurations = (data: {
  sharedConfigurations: string[];
  salesPartnerCode: string;
  salesPartnerMessage: string;
}): Promise<boolean> => {
  return occFetch(occUrl("/store-finder/sendLinearConfigurations"), {
    body: JSON.stringify(data),
    method: "POST",
    headers: { "Content-Type": "application/json" },
  }).then((response) => {
    if (!response.ok) {
      throw alert("Error status: " + response.status + ", please try again");
    } else {
      return true;
    }
  });
};
